<template>
    <div class="flex justify-center flex-wrap">
        <div class='text-center'>
            <a v-if="templateArgs.data.arquivo" :href='templateArgs.data.arquivo' target="_blank" class='btn btn btn-grey btn-sm' title='Abrir'>
                <i class='fa fa-arrow-right'></i> Download
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'templateAbrir',
    data: () => ({
        templateArgs: {}
    })
}
</script>

<style lang="scss" scoped>
</style>